import type { IContactsPerCompanyFilterDto } from "app/pages/sales-intelligence/domain/contacts/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculatePrimitiveDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";

export default class FindContactLimitResultsFilter extends FilterPanelBaseFilter<IContactsPerCompanyFilterDto, number> {
    constructor(deps: IFilterPanelBaseFilterDeps<IContactsPerCompanyFilterDto, number>) {
        super(deps);
    }

    calculateValueDelta(
        previousValue: IContactsPerCompanyFilterDto | undefined,
        newValue: IContactsPerCompanyFilterDto | undefined,
    ): FilterValueDelta<number> {
        return calculatePrimitiveDelta(previousValue?.contactsCount, newValue?.contactsCount);
    }
}
